/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React, { useCallback, useState, useContext } from 'react'
import { useServiceContext } from '../../../root'
import { changeRequestTypesApiService } from '../../../services/api/api.changerequesttypes'
import { RcmTableDataWrapper } from '../../../components/rcm-table/RcmTableDataWrapper'
import { RcmTableDataContext } from '../../../components/rcm-table/RcmTableDataContext'
import RcmTableFilterTrigger from '../../../components/rcm-table/RcmTableFilterTrigger'
import Loader from '../../../components/shared/Loader'
import PageMenu from './PageMenu'
import Table from './Table'
import TableFilter from './TableFilter'
import ModalEdit from './Actions/ModalEdit'

const WorkflowTemplatesContent: React.FC = () => {
  const tableContext = useContext(RcmTableDataContext)
  const context = useServiceContext()
  const { translate } = context.service.filter
  const [selectedTemplate, setSelectedTemplate] = useState<any | undefined>(undefined)
  const [showEditModal, setShowEditModal] = useState(false)
  const [isExporting, setIsExporting] = useState(false)

  const handleOpenEditModal = (template?: any) => {
    setSelectedTemplate(template)
    setShowEditModal(true)
  }

  const handleCloseModal = () => {
    setShowEditModal(false)
    setSelectedTemplate(undefined)
  }

  return (
    <>
      <Loader blocking={isExporting}>
        <div className="row">
          <div className="col-xs-12">
            <div className="d-flex flex-wrap" style={{ paddingBottom: '1%' }}>
              <h1 className="align-left align-top" id="00d17723-954a-4274-9fb2-c9c4549f61d3" style={{ margin: '0' }}>
                {translate('WORKFLOW_TEMPLATES_TITLE')}
              </h1>

              <div className="align-right align-bottom d-flex">
                <PageMenu
                  onAdd={() => handleOpenEditModal()}
                  onExportStart={() => setIsExporting(true)}
                  onExportEnd={() => setIsExporting(false)}
                />
                <RcmTableFilterTrigger />
              </div>
            </div>

            <TableFilter />
            <Table
              onRowClick={handleOpenEditModal}
              onDeleteSuccess={() => tableContext?.refreshTable()}
              onExportStart={() => setIsExporting(true)}
              onExportEnd={() => setIsExporting(false)}
            />
          </div>
        </div>
        {showEditModal && <ModalEdit template={selectedTemplate} onClose={handleCloseModal} />}
      </Loader>
    </>
  )
}

const WorkflowTemplatesPage: React.FC = () => {
  // Create loadData function for RcmTableDataWrapper
  const loadData = useCallback(async (pagingParams: any, filter: any) => {
    console.log('Load workflow templates data with filter:', filter)
    try {
      const params: any = {
        id:
          filter?.templates && filter.templates.length > 0
            ? filter.templates.map((t: any) => String(t.value || t.id || t))
            : undefined,
        pageStart: pagingParams.pageStart || 0,
        pageSize: pagingParams.pageSize || 15,
        sortBy: pagingParams.sortBy || 'NAME',
        sortDesc: pagingParams.sortDesc !== undefined ? pagingParams.sortDesc : false
      }

      const response: any = await changeRequestTypesApiService.getAllForTable(params)

      return {
        elements: response.elements || [],
        totalElements: response.totalElements || 0
      }
    } catch (error) {
      console.error('Error loading workflow templates:', error)
      return {
        elements: [],
        totalElements: 0
      }
    }
  }, [])

  return (
    <div className="mcc-content-frame theme-sandman">
      <RcmTableDataWrapper
        loadData={loadData}
        defaultSortBy="NAME"
        defaultSortDesc={false}
        persistenceKey="settingsWorkflowTemplates"
        doPreload={true}
      >
        <WorkflowTemplatesContent />
      </RcmTableDataWrapper>
    </div>
  )
}

export default WorkflowTemplatesPage
